#import "../../fragments/UserFragment.graphql"
#import "../../fragments/BBcodeFragment.graphql"

query GetBrickfilmQuery($id: ID!) {
  node(id: $id) {
    id
    ... on Brickfilm {
      author {
        ...UserFragment
      }
      title
      description
      type
      language
      slug
      runtime
      includesPeter
      containsExplicitContent
      picture
      isArchived
      isFilmOfTheMonth
      isFilmOfTheWeek
      isSponsored
      isRecommended
      picturePath
      isAbandoned
      containsExplicitContent
      allowedToReuse
      isUnavailable
      videoLinks: links(isEditable: true, kind: FILM) {
        id
        link
        type
        reference
      }
      teaserLinks: links(isEditable: true, kind: TEASER) {
        id
        link
        type
        reference
      }

      castMembers {
        id
        role
        additionnalInformation
        memberName
        member {
          ...UserFragment
        }
      }
      productionNotes {
        id
        createdAt
        content {
          ...BBcodeFragment
        }
      }
      makingOf {
        ...BBcodeFragment
      }
      allowedActions
    }
  }
}
